<template>
    <div>
      <common-dialog
        ref="dialog"
        width="50%"
        title="最近的十次单价"
        id-key="ClassId"
        :line-form="true"
        form-label-width="85px"
        :save-func="() => {}"
        @close-saved="$emit('close-saved')"
      >
        <template slot="form">
          <el-table
            border
            :data="tableData"
            @row-click="rowClick"
            :row-style="tableRowClassName"
            class="tableList"
          >
            <el-table-column label="单据日期" prop="DocDate" align="left">
             <template slot-scope="{ row }">
                <span>{{ row.DocDate }}</span>
              </template>
            </el-table-column>   
            <el-table-column label="单据编号" min-width="100px" prop="DocNo" align="left">
             <template slot-scope="{ row }">
                <span>{{ row.DocNo }}</span>
              </template>
            </el-table-column>
            <el-table-column label="客户" min-width="140px" prop="TradeUnitName" align="left">
             <template slot-scope="{ row }">
                <span>{{ row.TradeUnitName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="数量" prop="SaQuantity" align="right">
             <template slot-scope="{ row }">
                <span>{{ row.SaQuantity }}</span>
              </template>
            </el-table-column>
            <el-table-column label="单价" prop="Price" align="right">
             <template slot-scope="{ row }">
                <span>{{ row.Price }}</span>
              </template>
            </el-table-column>
            <el-table-column label="含税单价" prop="TaxPrice" align="right">
             <template slot-scope="{ row }">
                <span>{{ row.TaxPrice }}</span>
              </template>
            </el-table-column>
            <el-table-column label="交易笔数" prop="TradeCount" align="right">
             <template slot-scope="{ row }">
                <span>{{ row.TradeCount }}</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      <div class="box">
        <strong style="color: red;">说明：</strong> 以上十次价格记录按【客户+存货+计量单位+单价】进行了合并，合并条数就是‘交易笔数’。
      </div>
       <template slot="footer">
          <el-button type="primary" @click="save" >确定</el-button>
          <el-button @click="closeDialog">关 闭</el-button>
      </template>
      </common-dialog>
    </div>
  </template>
  <script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
    },
    data() {
      return {
        tableData: [],
        currentRowPrice: 0,
        currentId: 0,
        api: require("@/api/sa/saDoc").default,
        // trendData: iForm.Data,
      };
    },
    methods: {
      toDateStringByFormat(value, format) {
        if (!value) return "";
        let m = this.$moment(value);
        if (!m.isValid()) {
          return "";
        }
        return m.format(format);
      },
      tableRowClassName({ row }){
        let style = {
          "background-color": "#ebc887 !important"
        }
        if(row.Id === this.currentId ){

          return style;
        }else{
          return {
            
            "background-color": "#fff !important"
          }
        }
        
      },
      rowClick(row){
        this.currentId = row.Id;
        this.currentRowPrice = row.Price;
      },
      setData(ProductName, TradeUnitName = ""){
          this.api.getRecentPrice({ProductName, TradeUnitName, PageIndex: 1, PageSize: 10}).then(res => {
              if(res.Code === 0){
                  res.Data.forEach(item => {
                    item.DocDate = this.toDateStringByFormat(item.DocDate, "YYYY-MM-DD")
                  })
                  this.tableData = res.Data;
              }
          })
      },
      save(){
        this.currentId = 0;
        this.$emit('save', this.currentRowPrice)
        this.close()
      },
      closeDialog(){
        this.currentId = 0;
        this.close()
      }
    }
  
  };
  </script>
  
  <style lang="scss">
  .box{
    margin-top: 8px;
  }
  .el-table--enable-row-hover .el-table__body tr:hover > td {
	  background-color: transparent !important;
    }   
  </style>
  